import { Subscription } from 'rxjs';
import { Directive, ElementRef, HostListener, Input, SimpleChanges, OnChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { ContenteditableModelDirective } from '@techmore/share';

@Directive({
  selector: '[appEditableContentPlaceholder]',
  exportAs: 'editableContentPlaceholder',
})
export class EditableContentPlaceholderDirective implements OnChanges, AfterViewInit, OnDestroy {
  @Input('appEditableContentPlaceholder') placeholder: string;
  el: HTMLElement;
  isFocus = false;
  isTextExisting = false;
  subc: Subscription;

  constructor(
    private elRef: ElementRef,
    private contenteditableModelDirective: ContenteditableModelDirective,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.setPlaceholder(this.placeholder);
  }

  ngAfterViewInit(): void {
    this.el = this.elRef.nativeElement;

    if (this.contenteditableModelDirective.model) {
      this.isTextExisting = true;
    }

    this.setPlaceholder(this.placeholder);

    this.subc = this.contenteditableModelDirective.update.subscribe(v => {
      this.isTextExisting = !!v;
      this.setPlaceholder(this.placeholder);
    });
  }

  ngOnDestroy(): void {
    if (this.subc) {
      this.subc.unsubscribe();
      delete this.subc;
    }
  }

  @HostListener('focus')
  onFocus() {
    this.isFocus = true;
    this.setPlaceholder(this.placeholder);
  }

  @HostListener('blur')
  onBlur() {
    this.isFocus = false;
    this.setPlaceholder(this.placeholder);
  }

  setPlaceholder(placeholder: string) {
    if (placeholder && this.el && this.el.isContentEditable) {
      if (this.isFocus || this.isTextExisting) {
        this.el.dataset.placeholder = '';
      } else {
        this.el.dataset.placeholder = placeholder;
      }
    }
  }
}
